<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="用户管理">
      <!--            <a-button slot="extra" type="primary" @click="handleNewUser">新建用户</a-button>-->
      <a-form layout="inline" @submit="handleSubmit" :form="form">
        <a-form-item label="用户名称(昵称)">
          <a-input
            v-model="searchP.keyword"
            placeholder="请输入用户名称(昵称)"
          ></a-input>
        </a-form-item>
        <a-form-item label="用户UID">
          <a-input v-model="searchP.uid" placeholder="请输入用户UID"></a-input>
        </a-form-item>
        <a-form-item label="手机号">
          <a-input
            v-model="searchP.phone"
            placeholder="请输入用户手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="账号">
          <a-input
            v-model="searchP.identitykey"
            placeholder="请输入账号"
          ></a-input>
        </a-form-item>

        <a-form-item label="状态">
          <a-select
            v-model="searchP.status"
            placeholder=""
            style="width: 100px"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">使用</a-select-option>
            <a-select-option value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            htmlType="submit"
            :key="this.loading.key"
            @click="getUserList"
            >筛选</a-button
          >
        </a-form-item>
        <a-form-item>
          <a-button
            type="default"
            htmlType="submit"
            :key="this.loading.key"
            @click="handleSearchReset"
            >重置
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <!-- 系统列表 -->
    <a-table
      :columns="columns"
      :data-source="data"
      :pagination="false"
      :loading="tLoading"
      rowKey="id"
    >
      <span slot="status" slot-scope="text">{{ statusMap[text] }}</span>
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations">
          <span>
            <router-link :to="{ path: 'edituser', query: { uid: record.uid } }"
              >编辑</router-link
            ></span
          >
        </div>
      </template>
    </a-table>
    <a-pagination
      class="my_pagenation"
      v-model="searchP.page"
      :total="searchP.total"
      @change="handlePageChange"
      show-less-items
      show-quick-jumper
    />
  </div>
</template>
<script>
const statusMap = {
    1: "使用",
    2: "禁用",
};
const columns = [
    {
        title: "用户Uid",
        dataIndex: "uid",
        align: "left",
        width: 200,
    },
    {
        title: "手机号",
        dataIndex: "phone",
        align: "left",
        width: 120,
    },
    {
        title: "用户名称",
        dataIndex: "username",
        align: "center",
        width: 120,
        ellipsises: true,
    },
    {
        title: "用户昵称",
        dataIndex: "nickname",
        align: "center",
        width: 120,
        ellipsises: true,
    },
    {
        title: "用户状态",
        dataIndex: "userstate",
        align: "center",
        width: 100,
        scopedSlots: { customRender: "status" },
        ellipsises: true,
    },
    {
        title: "注册来源",
        dataIndex: "registersource",
        align: "center",
        width: 120,
        ellipsises: true,
    },
    {
        title: "操作",
        dataIndex: "operation",
        align: "center",
        width: 120,
        scopedSlots: { customRender: "operation" },
    },
];

const data = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            statusMap,
            searchP: {
                keyword: "",
                userstate: "",
                uid: "",
                total: 0,
                pageSize: 0,
                page: undefined,
                phone: "",
                identitykey: "",
            },
            tLoading: true,
        };
    },
    methods: {
        getUserList() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            };
            this.tLoading = true;
            this.$store
                .dispatch({
                    type: "ums/searchUserList",
                    params: c_params,
                })
                .then((res) => {
                    console.log(res);
                    this.tLoading = false;
                    let result = res.data.data;
                    this.data = result.list;
                    this.searchP.total = result.totalRecords;
                    this.searchP.pageSize = result.pageSize;
                    this.searchP.page = result.page;
                });
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p;
            this.updateRoute();
        },
        updateRoute() {
            this.$router.push({
                query: {
                    keyword: this.searchP.keyword,
                    userstate: this.searchP.userstate,
                    uid: this.searchP.uid,
                    page: this.searchP.page,
                },
            });
        },
        handleSearchReset() {
            this.searchP.page = 1;
            this.searchP.keyword = "";
            this.searchP.userstate = "";
            this.searchP.uid = "";
            this.updateRoute();
        },
        handleNewUser() {
            this.$router.push({
                path: "addUser",
            });
        },
        handleSubmit(e) {
            e.preventDefault();
            this.searchP.page = 1;
            this.updateRoute();
        },
    },

    components: {},
    watch: {
        $route() {
            this.$router.go(0);
        },
    },
    mounted() {
        let query = this.$route.query;
        this.searchP.keyword = query.keyword ? query.keyword : "";
        this.searchP.userstate = query.userstate ? query.userstate : "";
        this.searchP.uid = query.uid ? query.uid : "";
        this.searchP.page = query.page ? +query.page : 1;

        this.getUserList();
    },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}

td {
  padding: 10px 10px;
}
</style>
